import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import NotAuthorized from '../../assets/svg/503.svg'
import Button from '../../components/button';
  
function UnauthorizedPage() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const history = useHistory();  

  return (
    <div className='flex items-center justify-center flex-col min-h-[91vh] '>
        <div className='flex items-center flex-col max-h-[20%] max-w-[20%] '>
            <img className="object-contain" src={NotAuthorized} alt="" />
        </div>
      
      <div className='flex flex-col text-center '>
        <span className='header-2 md:header-1'>We are Sorry...</span>
        <div className='max-w-[700px] mt-2 flex flex-col items-center'>
        <span className='p3 md:header-5-regular'>The page you are trying to access has restricted access<br/>Please refer to you system administrator.</span>
           <div className='w-full md:w-[220px] mt-4 md:mt-4 h-[56px]'>
            <Button
              text='Back'
              type='submit'
              className='h-[56px]'
              onClick={() => history.goBack()}
            />
          </div>
          
        </div>

      </div>

    </div>
  )
}

export default UnauthorizedPage;